import script from "./CustomerForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerForm.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerForm.vue?vue&type=style&index=0&id=5af9973e&scoped=true&lang=scss"
import "./CustomerForm.vue?vue&type=style&index=1&id=5af9973e&lang=scss"

import exportComponent from "/var/www/twledodo-booking-rododo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af9973e"]])

export default __exports__